import { Alert, AlertColor } from '@mui/material';
import { FC } from 'react';
import { IToastifyComponent } from './types';
// ==========================================:
const ToastifyComponent: FC<IToastifyComponent> = ({ message, toastProps }) => {
	return (
		<Alert
			variant="filled"
			severity={(toastProps?.type ?? 'info') as AlertColor}
			// plain-text messages may contain line breaks (e.g. the operator's message of a blocked action)
			sx={{ height: '100%', whiteSpace: 'pre-line' }}
		>
			{message}
		</Alert>
	);
};

export default ToastifyComponent;
